"use client";

import cnBind from "classnames/bind";

import { ModalCallBack } from "@/components/_Modals/ModalCallBack";
import { useOnboardModal } from "@/shared/hooks/useOnboardModal";
import { trackBeautyCampaignEvent } from "@/shared/utils/beautyCampaignAnalytics";
import type { PublicCampaign } from "@/shared/campaign/beautyCampaign";
import { isCampaignOfferActive } from "@/shared/campaign/beautyCampaign";

import styles from "./BeautyCampaignBlocks.module.scss";

const cx = cnBind.bind(styles);

type Props = {
    campaign: PublicCampaign | null;
};

export function BeautyCampaignBlocks({ campaign }: Props) {
    const { isModalOpen, leadIntent, openSaasModal, closeModal } = useOnboardModal();
    const offer = isCampaignOfferActive(campaign);

    /** Same flow as «Попробовать бесплатно» / hero CTA — create tenant, not consultation lead. */
    const onSiteCta = () => {
        trackBeautyCampaignEvent("beauty_campaign_site_upsell_click", campaign);
        if (offer) {
            trackBeautyCampaignEvent("beauty_campaign_cta_click", campaign, { source_ui: "site_upsell" });
            trackBeautyCampaignEvent("beauty_campaign_signup_start", campaign, { source_ui: "site_upsell" });
            openSaasModal("start", "Beauty 100", {
                industryPreset: "BEAUTY",
                leadSource: "beauty_100_2026_site_upsell",
                campaignCode: campaign?.campaign || "BEAUTY_100_2026",
            });
            return;
        }
        openSaasModal("demo", "Demo", {
            industryPreset: "BEAUTY",
            leadSource: "beauty_site_upsell",
        });
    };

    return (
        <section className={cx("blocks")} aria-label="Beauty 100 — дополнительно">
            <div className={cx("card")}>
                <h2>Уже используете DIKIDI или YCLIENTS?</h2>
                <p>
                    Не нужно сразу отказываться от привычного сервиса. Запустите TEZAM параллельно и оцените
                    его на реальных клиентах.
                </p>
            </div>
            <div className={cx("card", "site")}>
                <h2>Хотите собственный сайт салона?</h2>
                <p>
                    {offer
                        ? "TEZAM Beauty уже работает бесплатно. Полноценный сайт на вашем домене можно подключить отдельно."
                        : "Полноценный сайт на вашем домене подключается отдельно от Mini App и CRM."}
                </p>
                <button type="button" onClick={onSiteCta}>
                    Подключить сайт
                </button>
            </div>
            <ModalCallBack isOpen={isModalOpen} onClose={closeModal} leadIntent={leadIntent} />
        </section>
    );
}
